import React from 'react';
import {
  Card,
  CardBody,
  Button,
} from 'reactstrap';


export type StatusColor = 'red' | 'amber' | 'green';

const STATUS_COLOR_MAP: Record<StatusColor, string> = {
  red: '#c62828',
  amber: '#f57c00',
  green: '#57b745',
};


type StatusBannerProps = {
  status?: StatusColor;
  icon?: React.ReactNode;
  text: string | React.ReactNode;
  buttonText?: string;
  buttonHref?: string;
  onButtonClick?: () => void;
};

const StatusBanner: React.FC<StatusBannerProps> = ({
  status = 'red',
  icon,
  text,
  buttonText,
  buttonHref,
  onButtonClick,
} : StatusBannerProps) => {

  const accentColor = STATUS_COLOR_MAP[status];
  return (
    <Card
      className="border-0 mb-1"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
      }}>
      <CardBody
        className="d-flex align-items-center gap-3 p-1"
        style={{
          border: '1px solid #e5e7eb',
        }}>
        <div
          style={{
            width: '6px',
            alignSelf: 'stretch',
            backgroundColor: accentColor,
            borderRadius: '6px',
          }}
        />
        {icon && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              backgroundColor: `${accentColor}1A`,
              color: accentColor,
              flexShrink: 0,
            }}>
            {icon}
          </div>
        )}
        <div
          className="flex-grow-1 fw-semibold"
          style={{
            color: accentColor,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          <strong>{text}</strong>
        </div>
        {buttonText && (
                <Button
                    color="success"
                    tag={buttonHref ? 'a' : 'button'}
                    href={buttonHref}
                    onClick={onButtonClick}
                    title={buttonText}>
                    {buttonText}
                </Button>

        )}
      </CardBody>
    </Card>
  );
};

export default StatusBanner;